<template>
  <ItemRow
    v-bind="$attrs"
    :selected="itemData.selected"
    v-on="$listeners"
  >
    <ItemWithLabel
      v-for="(column, index) in columns"
      :key="index"
      :column="column"
    >
      <span
        v-if="column.dataFieldName === 'active'"
        :class="$style.buttonProperty"
      >
        <Icon
          :class="$style.iconWarring"
          icon="error"
          :scale="1.5"
        />
      </span>
      <span v-else>
        <div v-if="column.dataFieldName === 'displayName'">
          <Link
            :class="$style.link"
            :text="displayName"
            :to="editLink"
          />
        </div>
        <div v-else-if="column.dataFieldName === 'status'">
          <StatusBadge
            :status="statusColor(itemData[column.dataFieldName])"
            :text="itemData[column.dataFieldName]"
          />
        </div>
        <div
          v-else-if="column.dataFieldName === 'os'"
          :class="$style.osDisplay"
        >
          <Icon
            :class="$style.icon"
            :icon="iconName(itemData)"
            :scale="1.5"
          />
          <div> {{ itemData[column.dataFieldName] }} </div>
        </div>
        <div v-else> {{ itemData[column.dataFieldName] }} </div>
      </span>
    </ItemWithLabel>
  </ItemRow>
</template>

<script>
import {
  Icon,
  ItemRow,
  ItemWithLabel,
  Link,
  StatusBadge,
} from '@jumpcloud/ui-components';
import moment from 'moment';

export default {
  name: 'DeviceRow',

  components: {
    Icon,
    Link,
    ItemWithLabel,
    ItemRow,
    StatusBadge,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },
    itemData: {
      required: true,
      type: Object,
    },
  },

  computed: {
    displayName() {
      return this.itemData.displayName || '[No Name]';
    },

    editLink() {
      return `/devices/${this.itemData.id}/details`;
    },
  },

  methods: {
    iconName(itemData) {
      return itemData.osFamily === 'darwin' ? 'apple' : itemData.osFamily;
    },

    statusColor(itemStatus) {
      const statusColor = itemStatus === 'Active' ? 'success' : 'error';
      return statusColor;
    },

    transformDate(timestamp) {
      return moment(timestamp).utc().fromNow();
    },
  },
};
</script>

<style module scoped>
.column {
  align-content: center;
  display: flex;
}

.icon:not(.legacyOverride):not(.legacyOverride) {
  align-items: center;
  color: var(--icon-color, var(--jc-text-color));
  display: flex;
  height: 1.5em;
  width: 1.5em;
}

.osDisplay {
  align-items: center;
  display: flex;
  place-content: flex-start;
}

.iconWarring {
  background: var(--jc-color-error-strong);
  border-radius: 100%;
  color: var(--jc-color-background);
}

.link {
  display: inline;
}

.label {
  align-items: flex-start;
  display: inline-flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  margin-left: 5px;
}

</style>
